module.exports = __webpack_public_path__ + "static/img/vasen.a377fd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vasen.jpg
// module id = 305
// module chunks = 0